import axios from 'axios';
import { trackPromise } from 'react-promise-tracker';
import { BehaviorSubject } from 'rxjs';

//base urls to be extended upon request
const DEV_URL = process.env.REACT_APP_DEV_APIURL;
const COMP_URL = process.env.REACT_APP_COMP_APIURL;
const ADMIN_URL = process.env.REACT_APP_ADMIN_APIURL;

//Observables declarations
export const userData$ = new BehaviorSubject();
export const user$ = new BehaviorSubject();

const getUserData = () => {
  const token = localStorage.getItem('userData');

  if (token) {
    const parsedToken = JSON.parse(token);
    return parsedToken;
  } else {
    return false;
  }
};

const setAuthHeader = () => {
  const token = getUserData();
  if (token) {
    return token.token;
  } else {
    return '';
  }
};

const checkLoggedIn = () => {
  const token = getUserData();
  return Boolean(token);
};

const config = {
  headers: {
    'Content-Type': 'application/json',
    authorization: setAuthHeader(),
  },
};

//Only admins and developers can access (set in backend)
const getUserById = async (userData) => {
  const config = {
    headers: {
      'Content-Type': 'application/json',
      authorization: userData.token,
    },
  };

  if (userData.role === 'developer') {
    const result = await axios.get(`${DEV_URL}/${userData.userId}`, config);

    user$.next(result);
  } else if (userData.role === 'company') {
    const result = await axios.get(`${COMP_URL}/${userData.userId}`, config);

    user$.next(result);
  } else if (userData.role === 'admin') {
    const result = await axios.get(`${ADMIN_URL}/${userData.userId}`, config);
    user$.next(result);
  }
};

//getDeveloperById
const getDeveloperById = async (userData, id) => {
  const config = {
    headers: {
      'Content-Type': 'application/json',
      authorization: userData.token,
    },
  };
  const result = await axios.get(`${DEV_URL}/${id}`, config);
  return result;
};

//getCompanyById
const getCompanyById = async (userData, id) => {
  const config = {
    headers: {
      'Content-Type': 'application/json',
      authorization: userData.token,
    },
  };
  const result = await axios.get(`${COMP_URL}/${id}`, config);
  return result;
};

//getAllDevelopers
const getAllDevelopers = async (userData) => {
  const config = {
    headers: {
      'Content-Type': 'application/json',
      authorization: userData.token,
    },
  };
  const result = await axios.get(`${DEV_URL}`, config);
  return result;
};

//getAllCompaies
const getAllCompanies = async (userData) => {
  const config = {
    headers: {
      'Content-Type': 'application/json',
      authorization: userData.token,
    },
  };

  const result = await axios.get(`${COMP_URL}`, config);
  return result;
};

const applyJob = async (data, userData) => {
  const config = {
    headers: {
      'Content-Type': 'application/json',
      authorization: userData.token,
    },
  };
  const result = await axios.patch(
    `${DEV_URL}/apply-job/${userData.userId}`,
    data,
    config
  );
  return result;
};

const removeApplication = async (jobId, userData) => {
  const config = {
    headers: {
      'Content-Type': 'application/json',
      authorization: userData.token,
    },
  };

  const result = await axios.patch(
    `${DEV_URL}/remove-job/${jobId}`,
    {},
    config
  );
  return result.data;
};
// populate userData observable with every request data.
const registerFunction = async (formData) => {
  try {
    if (formData.role === 'developer') {
      const result = await axios.post(`${DEV_URL}/register`, formData, config);
      return result.data;
    } else if (formData.role === 'company') {
      const result = await axios.post(`${COMP_URL}/register`, formData, config);
      return result.data;
    } else if (formData.role === 'admin') {
      const result = await axios.post(
        `${ADMIN_URL}/register`,
        formData,
        config
      );
      return result.data;
    }
  } catch (error) {
    if (error.response) {
      return error.response.data;
    }
  }
};

const loginUser = async (formData) => {
  const data = {
    email: formData.email,
    password: formData.password,
  };
  if (formData.role === 'developer') {
    //call developer login
    const result = await axios.post(`${DEV_URL}/login`, data, config);
    if (result.data.success === true) {
      localStorage.setItem('userData', JSON.stringify(result.data.data));
      console.log('set storage');
      return result;
    } else {
      return result;
    }
  } else if (formData.role === 'company') {
    //call company login
    const result = await axios.post(`${COMP_URL}/login`, data, config);
    if (result.data.success === true) {
      localStorage.setItem('userData', JSON.stringify(result.data.data));
      return result;
    } else {
      return result;
    }
  } else if (formData.role === 'admin') {
    const result = await axios.post(`${ADMIN_URL}/login`, data, config);
    if (result.data.success === true) {
      localStorage.setItem('userData', JSON.stringify(result.data.data));
      return result;
    }
  }
};

const updateUser = async (role, id, formData, userData) => {
  const config = {
    headers: {
      'Content-Type': 'application/json',
      authorization: userData.token,
    },
  };

  if (role === 'developer') {
    const user = { user: { ...formData } };
    const result = await axios.patch(`${DEV_URL}/${id}`, user, config);
    return result;
  } else if (role === 'company') {
    const company = { company: { ...formData } };
    const result = await axios.patch(`${COMP_URL}/${id}`, company, config);
    return result;
  }
};

const logoutUser = () => {
  localStorage.removeItem('userData');
  window.location.reload();
};

const deleteUser = async (id, role, userData) => {
  const config = {
    headers: {
      'Content-Type': 'application/json',
      authorization: userData.token,
    },
  };
  if (role === 'developer') {
    const result = await axios.delete(`${DEV_URL}/${id}`, config);
    return result;
  } else if (role === 'company') {
    //call delete company when implemented
  }
};

const authService = {
  registerFunction,
  loginUser,
  getUserById,
  getDeveloperById,
  getCompanyById,
  getAllDevelopers,
  getAllCompanies,
  applyJob,
  removeApplication,
  checkLoggedIn,
  getUserData,
  setAuthHeader,
  updateUser,
  logoutUser,
  deleteUser,
};

export default authService;
